import styled from "styled-components";
import { SharingIcon } from "src/website-apps/shared/components/stubhub-sharing";

export const StyledHeroHeader = styled.div<{ backgroundImageUrl: string; backgroundYPosition?: string }>`
  background-image: ${(props) => `url(${props.backgroundImageUrl})`};
  background-position: 75% 0%;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 5% 0 24px 0;
  position: relative;
  height: auto;
  width: 100%;
  z-index: 0;

  &:before {
    background-image: linear-gradient(
      0deg,
      #ffffff 8.43%,
      rgba(255, 255, 255, 0.202475) 145%,
      rgba(255, 255, 255, 0) 295.42%
    );
    bottom: 0;
    content: "";
    height: 101%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
    z-index: -1;
  }

  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    background-position: ${(props) => `0% ${props.backgroundYPosition ?? "center"}`};
  }
`;

export const StyledTitle = styled.h1`
  ${({
    theme: {
      typography: { fontWeight, getStyles, variant },
    },
  }) => getStyles(variant.title1, fontWeight.bold)};
  color: ${(props) => props.theme.colors.textDarker};
  margin-bottom: ${(props) => props.theme.spacing(0.5)};
`;

export const StyledSubtitle = styled.p`
  ${({
    theme: {
      typography: { getStyles, variant },
    },
  }) => getStyles(variant.body1)};
  color: ${(props) => props.theme.colors.textPrimary};
  margin-bottom: ${(props) => props.theme.spacing(5)};
`;

export const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${(props) => props.theme.spacing(8, 0)};
  width: 100%;
`;

export const ButtonDiv = styled.div`
  display: flex;
  position: relative;
  gap: ${(props) => props.theme.spacing(4)};
`;

export const HeroHeaderSharingIcon = styled(SharingIcon)`
  svg {
    width: 42px;
    height: 42px;
  }
`;
